module.exports = __webpack_public_path__ + "img/3-3.efdc10f6.svg";